import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  FetchResult,
  InMemoryCache,
  Observable,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { backend_url } from '../../constants';
import { getAccessToken, refreshAuthTokens } from './utils';
import { logoutFromUI } from '../../routes/ProfilePages/ProfileContent/utils';
import { GraphQLError } from 'graphql';

const httpLink = createHttpLink({
  uri: `${backend_url}/graphql/`,
  credentials: 'include',
});

const authLink = setContext((_, { headers }) => {
  const token = getAccessToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        switch (err.extensions?.code) {
          case 'UNAUTHENTICATED':
            const isRefreshTokenAPICall =
              operation.operationName === 'refreshTokens';

            if (isRefreshTokenAPICall) return;

            const observable = new Observable<FetchResult<Record<string, any>>>(
              (observer) => {
                // used an annonymous function for using an async function
                (async () => {
                  try {
                    const tokens = await refreshAuthTokens();

                    if (!tokens.accessToken) {
                      throw new GraphQLError('Empty AccessToken');
                    }

                    // Retry the failed request
                    const subscriber = {
                      next: observer.next.bind(observer),
                      error: observer.error.bind(observer),
                      complete: observer.complete.bind(observer),
                    };

                    forward(operation).subscribe(subscriber);
                  } catch (err) {
                    console.log(
                      'trying to call refreshAuthTokens observable error',
                      err,
                    );
                    observer.error(err);
                  }
                })();
              },
            );

            return observable;
        }
      }
    }

    if (networkError) console.log(`[Network error]: ${networkError}`);
  },
);
export const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          getMyConversationActivities: {
            merge: false,
          },
        },
      },
    },
  }),
  credentials: 'include',
});
